import { PROGRAMME_NAME_FILTER, PROGRAMME_TYPE_FILTER } from './constants';
import {
  PROGRAMME_DISPLAY_MAP,
  PROGRAMME_TYPE_DISPLAY_MAP,
} from '../../components/ApplicationForm/constants';
import { type DropDownSelectOption } from '../../../../components';

export const programmeFilterOptions: DropDownSelectOption[] = [
  {
    value: PROGRAMME_NAME_FILTER.MASTER_OF_PHILOSOPHY,
    label: PROGRAMME_DISPLAY_MAP.MASTER_OF_PHILOSOPHY,
  },
  {
    value: PROGRAMME_NAME_FILTER.DOCTOR_OF_PHILOSOPHY,
    label: PROGRAMME_DISPLAY_MAP.DOCTOR_OF_PHILOSOPHY,
  },
];

export const programmeTypeFilterOptions: DropDownSelectOption[] = [
  {
    value: PROGRAMME_TYPE_FILTER.GENERAL_PROGRAMME,
    label: PROGRAMME_TYPE_DISPLAY_MAP.GENERAL_PROGRAMME,
  },
  {
    value: PROGRAMME_TYPE_FILTER.DUAL_PHD_DEGREE_PROGRAMME,
    label: PROGRAMME_TYPE_DISPLAY_MAP.DUAL_PHD_DEGREE_PROGRAMME,
  },

  {
    value: PROGRAMME_TYPE_FILTER.COLLABORATIVE_PHD_DEGREE_PROGRAMME,
    label: PROGRAMME_TYPE_DISPLAY_MAP.COLLABORATIVE_PHD_DEGREE_PROGRAMME,
  },
];
